/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Columns_Drag_HandleInputs */



/**
* | output |
* | --- |
* | "Drag to reorder" |
*
* @param {Editor_Table_Columns_Drag_HandleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_columns_drag_handle = /** @type {((inputs?: Editor_Table_Columns_Drag_HandleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Columns_Drag_HandleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Glisser pour reordonner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Neuanordnen ziehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascina per riordinare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перетащите, чтобы изменить порядок.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arrastrar para reordenar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拖动即可重新排序")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドラッグして並べ替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुन: व्यवस्थित करने के लिए खींचें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arraste para reordenar")
	return /** @type {LocalizedString} */ ("Drag to reorder")
});